import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { AccessDirect } from '@shared/interfaces/access-direct';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public isLoggedIn = false;
  public directAccess: Array<AccessDirect> = [];

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public authenticationService: AuthenticationService
  ) {
    authenticationService.isLoggedIn
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(result => {
        this.isLoggedIn = result;
      });
  }

  ngOnInit() {
    this.generalsService.itemMenu$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(result => {
        this.directAccess = this.generalsService.debugDirectAccess(result);
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }
}
